import React, {Component} from 'react';
import CustomRadio from './CustomRadio';
import {Field} from 'formik';
import get from 'lodash/get';
import Error from '../Error';
import classNames from 'classnames';

class SingleChoiceField extends Component {
    constructor(props) {
        super(props);
        const {validateDetail} = props;
        this.handleClick = this.handleClick.bind(this);
        this.validateDetail = validateDetail.bind(this);
    }

    getPreviousReference(index) {
        const {field, choices, previousContent} = this.props;

        if (previousContent && previousContent.type === 'staticImageGallery') {
            return `${field.name}_${choices[index].id}`;
        }
        return index;
    }

    handleClick(e) {
        const {field, previousContent} = this.props;

        // proxying the event
        field.onChange(e);
        // we ensure following Content exists and is of singleChoice type
        if (previousContent && previousContent.type === 'staticImageGallery') {
            const allTargets = document.querySelectorAll('.singlechoice-img');
            for (const target of allTargets) {
                target.classList.remove('singlechoice-img-selected');
            }
            const index = e.target.dataset['index'];
            const targetElement = document.querySelector(`#singlechoice-img-${this.getPreviousReference(index)}`);
            targetElement.classList.add('singlechoice-img-selected');
        }
    }

    render() {
        const {form, field, choices, previousContent} = this.props;

        return (
            <div className={classNames({'mobile-hidden': previousContent.type === 'staticImageGallery'})}>
                {choices.map((choice, index) => (
                    <React.Fragment key={index}>
                        <CustomRadio key={`${index}_value`} id={`singlechoice-${field.name}_${choice.id}`} name={field.name} value={choice.id}
                            data-index={index} checked={field.value === choice.id} onChange={this.handleClick}>{choice.value}</CustomRadio>
                        {choice.detail && field.value === choice.id &&
                            <div className={classNames('question', {error: get(form.errors, `${field.name}_${choice.id}_detail`)})}>
                                <Field key={`${index}_detail`} name={`${field.name}_${choice.id}_detail`} type="text" className="form-control"
                                    validate={this.validateDetail} />
                                {get(form.errors, `${field.name}_${choice.id}_detail`) ?
                                    <Error {...(get(form.errors, `${field.name}_${choice.id}_detail`))} /> :
                                    null}
                            </div>
                        }
                    </React.Fragment>
                ))}
            </div>
        );
    }
}

export default SingleChoiceField;
